<fo-toolbar [title]="title"></fo-toolbar>
@if (usersParts$ | async; as parts) {
  @switch (parts.state) {
    @case (state.Error) {
      <crm-error [@inOut]="'in'"> </crm-error>
    }
    @case (state.Loaded) {
      <div [@inOut]="'in'">
        <crm-list-container
          [list$]="usersPartsList$"
          (openEvent)="onOpen($event)"
        >
        </crm-list-container>
        @if (usersPartsList$ | async; as list) {
          @if (!list.length) {
            <crm-empty-warn
              message="thereAreNoPartsYet"
              actionLabel="addNewPart"
            ></crm-empty-warn>
          }
        }
      </div>
    }
  }
}
